<div class="authentication-bg min-vh-100">
  <div class="bg-overlay bg-white"></div>
  <!-- Language Switcher -->
  <div class="language-switcher-container">
    <app-language-switcher></app-language-switcher>
  </div>
  <div class="container">
    <div class="col-row">
      <div class="col-md-6">
        <div class="w-full">
          <div class="mb-4 mb-md-5 responsive-auth-header">
            <a routerLink="/" class="d-block auth-logo">
              <div class="d-flex gap-3">
                <img src="assets/images/HC-logo.svg" alt="HotelCard Logo" class="logo" />
                <img src="assets/images/hotelcard-text.svg" alt="HotelCard" class="hotelcard-text" />
                <span class="mt-3 responsive-divider">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="2"
                    height="30"
                    viewBox="0 0 2 30"
                    fill="none"
                    >
                    <path d="M1.24854 2.18557e-08L1.24853 30" stroke="white" />
                  </svg>
                </span>
                <span class="text-white extranet">Extranet</span>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="d-flex flex-column">
      <div class="row justify-content-center my-auto">
        <div class="col-lg-6">
          <div class="responsive-center-card responsive-auth-page-card">
            <div class="card auth-cover-card overflow-hidden">
              <div class="row g-0">
                <div class="col-lg-12">
                  <div class="login-form-card bg-white h-100 d-flex align-items-center justify-content-center auth-card">
                    <div class="w-full">
                      <!-- Invalid Link Error -->
                      @if (invalidLink) {
                        <div class="mb-4">
                          <h2 class="text-dark fw-bold mb-0 text-start">{{ 'AUTH.RESET_PASSWORD.TITLE' | translate }}</h2>
                        </div>
                        <div class="mb-4">
                          <p class="text-danger mb-3">
                            {{ 'AUTH.RESET_PASSWORD.INVALID_LINK' | translate }}
                          </p>
                          <a routerLink="/account/password-recovery" class="btn btn-primary w-100">
                            {{ 'AUTH.RESET_PASSWORD.REQUEST_NEW_LINK' | translate }}
                          </a>
                          <div class="mt-3 text-center">
                            <a routerLink="/account/login" class="text-decoration-underline forgot-password">
                              {{ 'AUTH.RESET_PASSWORD.BACK_TO_LOGIN' | translate }}
                            </a>
                          </div>
                        </div>
                      }

                      @if (!invalidLink) {
                        <!-- Title -->
                        <div class="mb-4">
                          <h2 class="text-dark fw-bold mb-0 text-start">{{ 'AUTH.RESET_PASSWORD.TITLE' | translate }}</h2>
                        </div>

                        <form [formGroup]="resetPasswordForm" (ngSubmit)="onSubmit()">
                        <!-- New Password Field -->
                        <div class="mb-3">
                          <label for="newPassword" class="form-label">{{ 'AUTH.RESET_PASSWORD.NEW_PASSWORD_LABEL' | translate }}</label>
                          <div class="position-relative d-flex">
                            <!-- TODO: account pages use dark theme — needs design review before migrating to hc-input -->
                            <input
                              [type]="showNewPassword ? 'text' : 'password'"
                              class="form-control form-input-dark password-input"
                              id="newPassword"
                              formControlName="newPassword"
                              autocomplete="new-password"
                              placeholder="••••••••"
                              [attr.aria-label]="'AUTH.RESET_PASSWORD.NEW_PASSWORD_LABEL' | translate"
                              aria-describedby="password-addon"
                              />
                              <!-- Show/Hide New Password Icon -->
                              <button
                                type="button"
                                class="position-absolute password-icon translate-middle-y pe-3 btn p-0 border-0 bg-transparent"
                                (click)="showNewPassword = !showNewPassword"
                                [attr.aria-label]="showNewPassword ? ('AUTH.LOGIN.HIDE_PASSWORD' | translate) : ('AUTH.LOGIN.SHOW_PASSWORD' | translate)"
                                >
                                <lucide-icon [name]="showNewPassword ? 'eye' : 'eye-off'"></lucide-icon>
                              </button>
                          </div>

                          <!-- Password validation hints -->
                          <app-password-hints [password]="newPassword?.value ?? null"></app-password-hints>
                        </div>

                        <!-- Confirm Password Field -->
                        <div class="mb-4">
                          <label for="confirmPassword" class="form-label text-muted">{{ 'AUTH.RESET_PASSWORD.CONFIRM_PASSWORD_LABEL' | translate }}</label>
                          <div class="position-relative d-flex">
                            <!-- TODO: account pages use dark theme — needs design review before migrating to hc-input -->
                            <input
                              [type]="showConfirmPassword ? 'text' : 'password'"
                              class="form-control form-input-dark password-input"
                              id="confirmPassword"
                              formControlName="confirmPassword"
                              autocomplete="new-password"
                              placeholder="••••••••"
                              [attr.aria-label]="'AUTH.RESET_PASSWORD.CONFIRM_PASSWORD_LABEL' | translate"
                              aria-describedby="password-addon"
                              />
                          <!-- Show/Hide Password Icon -->
                          <button
                            type="button"
                            class="position-absolute password-icon translate-middle-y pe-3 btn p-0 border-0 bg-transparent"
                            (click)="showConfirmPassword = !showConfirmPassword"
                            [attr.aria-label]="showConfirmPassword ? ('AUTH.LOGIN.HIDE_PASSWORD' | translate) : ('AUTH.LOGIN.SHOW_PASSWORD' | translate)"
                            >
                            <lucide-icon [name]="showConfirmPassword ? 'eye' : 'eye-off'"></lucide-icon>
                          </button>
                          </div>

                          <!-- Password match validation -->
                          @if (confirmPassword?.value) {
                            <div class="password-match mt-3">
                              <div class="d-flex align-items-center">
                                <lucide-icon [name]="passwordsMatch ? 'circle-check' : 'circle-x'" [class]="passwordsMatch ? 'text-success' : 'text-danger'" class="me-2 hint-icon"></lucide-icon>
                                <small [class]="passwordsMatch ? 'text-success fw-medium' : 'text-danger'">
                                  {{ passwordsMatch ? ('AUTH.RESET_EMAIL.PASSWORDS_MATCH' | translate) : ('AUTH.RESET_EMAIL.PASSWORDS_DONT_MATCH' | translate) }}
                                </small>
                              </div>
                            </div>
                          }
                        </div>

                        @if (submitted && hasPasswordCriteriaError) {
                          <div class="alert alert-danger" role="alert">
                            {{ 'AUTH.RESET_PASSWORD.PASSWORD_CRITERIA_ERROR' | translate }}
                          </div>
                        }

                        <!-- Submit Button -->
                        <div class="mt-4">
                          <hc-button
                            variant="primary"
                            [type]="'submit'"
                            size="md"
                            [disabled]="false"
                            [loading]="loading"
                            class="reset-email-btn"
                            [fullWidth]="true"
                          >
                            {{ loading ? ('AUTH.RESET_EMAIL.SUBMITTING' | translate) : ('AUTH.RESET_EMAIL.SUBMIT' | translate) }}
                          </hc-button>
                        </div>

                        <!-- Reset Error Message -->
                        @if (resetError) {
                          <div class="mt-3">
                            <p class="text-danger mb-3">
                              {{ 'AUTH.RESET_PASSWORD.FAILED_WITH_RESEND' | translate }}
                            </p>
                          </div>
                        }

                        <!-- Resend Reset Link Button -->
                        <div class="mt-3">
                          <hc-button
                            variant="secondary"
                            [type]="'button'"
                            [disabled]="resendLoading"
                            [loading]="resendLoading"
                            (clicked)="resendResetLink()"
                            [fullWidth]="true"
                          >
                            {{ resendLoading ? ('AUTH.RESET_PASSWORD.RESENDING' | translate) : ('AUTH.RESET_PASSWORD.RESEND_LINK' | translate) }}
                          </hc-button>
                        </div>
                      </form>
                      }
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
